import style from './loyaltyTermsAndConditionsPage.module.scss';
import { Row } from 'acscp/components/common/row';
import React from 'react';
import { FormattedHTMLMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { getArrayOfHTMLMessages, getArrayOfMessages } from 'acscp/components/intl/messageArray';

class LoyaltyTermsAndConditionsPageContentPresentational extends React.Component<InjectedIntlProps, {}> {
    render(): JSX.Element {
        const preamble = getArrayOfMessages(this.props.intl, 'components.gifts.loyaltyPage.termsandconditions.preamble');
        const eligibilityTitle = this.props.intl.formatMessage({id: 'components.gifts.loyaltyPage.termsandconditions.eligibility.title'});
        const eligibilityTerms = getArrayOfMessages(this.props.intl, 'components.gifts.loyaltyPage.termsandconditions.eligibility');
        const exclusionsTitle = this.props.intl.formatMessage({id: 'components.gifts.loyaltyPage.termsandconditions.exclusions.title'});
        const exclusionsTerms = getArrayOfMessages(this.props.intl, 'components.gifts.loyaltyPage.termsandconditions.exclusions');
        const loyaltyGiftTitle = this.props.intl.formatMessage({id: 'components.gifts.loyaltyPage.termsandconditions.loyaltygift.title'});
        const loyaltyGiftTerms = getArrayOfMessages(this.props.intl, 'components.gifts.loyaltyPage.termsandconditions.loyaltygift');
        const loyaltyPointTitle = this.props.intl.formatMessage(
            {id: 'components.gifts.loyaltyPage.termsandconditions.loyaltypoint.title'});
        const loyaltyPointTerms = getArrayOfMessages(this.props.intl, 'components.gifts.loyaltyPage.termsandconditions.loyaltypoint');
        const participatingOfficesTitle = this.props.intl.formatMessage(
            {id: 'components.gifts.loyaltyPage.termsandconditions.participatingoffices.title'});
        const participatingOfficesTerms = getArrayOfMessages(
            this.props.intl, 'components.gifts.loyaltyPage.termsandconditions.participatingoffices');
        const specificTitle = this.props.intl.formatMessage({id: 'components.gifts.loyaltyPage.termsandconditions.specific.title'});
        const specificTerms = getArrayOfHTMLMessages(this.props.intl, 'components.gifts.loyaltyPage.termsandconditions.specific');
        return (
            <Row>
                {preamble.map((message, index) => <div className={style.preamble} key={`preamble_${index}`}>{message}</div>)}
                {<div className={style.bulletsHeader}>{eligibilityTitle}</div>}
                {<ul className={style.TermsList}>
                    {
                        eligibilityTerms.map((message, index) => (
                            <li key={index}>{message}</li>
                        ))
                    }
                </ul>}
                {<div className={style.bulletsHeader}>{exclusionsTitle}</div>}
                {<ul className={style.TermsList}>
                    {
                        exclusionsTerms.map((message, index) => (
                            <li key={index}>{message}</li>
                        ))
                    }
                </ul>}
                {<div className={style.bulletsHeader}>{loyaltyGiftTitle}</div>}
                {<ul className={style.TermsList}>
                    {
                        loyaltyGiftTerms.map((message, index) => (
                            <li key={index}>{message}</li>
                        ))
                    }
                </ul>}
                {<div className={style.bulletsHeader}>{loyaltyPointTitle}</div>}
                {<ul className={style.TermsList}>
                    {
                        loyaltyPointTerms.map((message, index) => (
                            <li key={index}>{message}</li>
                        ))
                    }
                </ul>}
                {<div className={style.bulletsHeader}>{participatingOfficesTitle}</div>}
                {<ul className={style.TermsList}>
                    {
                        participatingOfficesTerms.map((message, index) => (
                            <li key={index}>{message}</li>
                        ))
                    }
                </ul>}
                {<div className={style.bulletsHeader}>{specificTitle}</div>}
                {<ol className={style.TermsList}>
                    {
                        specificTerms.map((message, index) => (
                            <li key={index}><FormattedHTMLMessage id={message} /></li>
                        ))
                    }
                </ol>}
            </Row>
        );
    }
}

const LoyaltyTermsAndConditionsPageContent = injectIntl<{}>(LoyaltyTermsAndConditionsPageContentPresentational);

export { LoyaltyTermsAndConditionsPageContent };
